module.exports = __webpack_public_path__ + "static/img/99.c0b0018.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/99.png
// module id = vMhI
// module chunks = 0